
let SlsTracker = null
let SlsTrackerLoadPromise = null

if (process.client) {
  SlsTrackerLoadPromise = import('@aliyun-sls/web-track-browser').then(module => {
    SlsTracker = module.default
    return SlsTracker
  })
}
import { useUserStore } from "~/stores/user";
import { isLogstoreEnabled } from "~/utils/analyticsEnv.js";
import { v4 as uuidv4 } from 'uuid'
const uuid = uuidv4()

const event_prefix = '22'

// 日志上传库名称：lip-sync
// 设置Cookie
function setCookie(name, value, daysToExpire) {
  var expires = ''
  if (daysToExpire) {
    var date = new Date()
    date.setTime(date.getTime() + daysToExpire * 24 * 60 * 60 * 1000)
    expires = '; expires=' + date.toUTCString()
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/'
}
// 获取Cookie
function getCookie(name) {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(';').shift()
  return null
}

function isCookieExpired(name) {
  // 尝试获取cookie的值
  const cookieValue = getCookie(name)
  // 如果获取不到值，则认为cookie已过期
  return cookieValue === null
}
function sendLog(eventType, otherParams = {}) {
  const config = useRuntimeConfig();
  if (!isLogstoreEnabled(config)) return;

  if (!SlsTracker) {
    if (SlsTrackerLoadPromise) {
      SlsTrackerLoadPromise.then(() => sendLog(eventType, otherParams)).catch(() => {})
    }
    return
  }
  if (isCookieExpired('user_id')) {
    setCookie('user_id', uuid, 7) // 设置一个有效期为1天的Cookie
  }
  let userName = ''
  if (sessionStorage.getItem('USERNAME')) {
    userName = JSON.parse(sessionStorage.getItem('USERNAME'))?.userName || ''
  }
  const globalFields = {
    event_type: `${event_prefix}${eventType}`,
    event_time: Math.round(Date.now() / 1000),
  }

  const logstore = config.public.logstore
  const LOGGER_SETTING = {
    host: 'us-west-1.log.aliyuncs.com',
    project: 'wapu-website',
    time: 0.5,
    count: 1,
    logstore,
  }
  // console.log(logstore, event_prefix, eventType, otherParams);
  const appSlsTracker = new SlsTracker(LOGGER_SETTING)
  appSlsTracker.send({
    ...globalFields,
    ...otherParams,
    ...getBrowser(),
  })
}

function getBrowser() {
  const EDGE_PATTERN = /edge\/([\d.]+)|edg\/([\d.]+)/
  const IE_PATTERN1 = /rv:([\d.]+)\) like gecko/
  const IE_PATTERN2 = /msie ([\d.]+)/
  const FIREFOX_PATTERN = /firefox\/([\d.]+)/
  const CHROME_PATTERN = /chrome\/([\d.]+)/
  const OPERA_PATTERN = /opera.([\d.]+)/
  const SAFARI_PATTERN = /version\/([\d.]+).*safari/

  let result = {}
  // 1. 获取UserAgent
  result.userAgent = window.navigator.userAgent
  let ua = window.navigator.userAgent.toLowerCase()
  // 2. 浏览器校验正则表达式
  if (regexTest(ua, EDGE_PATTERN)) {
    return getBrowserInfo(EDGE_PATTERN, 'Edge')
  }
  if (regexTest(ua, IE_PATTERN1)) {
    return getBrowserInfo(IE_PATTERN1, 'IE')
  }
  if (regexTest(ua, IE_PATTERN2)) {
    return getBrowserInfo(IE_PATTERN2, 'IE')
  }
  if (regexTest(ua, FIREFOX_PATTERN)) {
    return getBrowserInfo(FIREFOX_PATTERN, 'Firefox')
  }
  if (regexTest(ua, CHROME_PATTERN)) {
    return getBrowserInfo(CHROME_PATTERN, 'Chrome')
  }
  if (regexTest(ua, OPERA_PATTERN)) {
    return getBrowserInfo(OPERA_PATTERN, 'Opera')
  }
  if (regexTest(ua, SAFARI_PATTERN)) {
    return getBrowserInfo(SAFARI_PATTERN, 'Safari')
  }
  result.browser = ''
  result.version = '0'
  result.userAgent = ua
  result.platform = ''
  result.language = ''
  return result
}

function getBrowserInfo(pattern, type) {
  let s
  let result = {}
  let ua = window.navigator.userAgent
  s = ua.toLowerCase().match(pattern)
  result.version = s[0]
  result.userAgent = ua
  result.browser = type
  result.platform = window.navigator.platform
  result.language = window.navigator.language
  return result
}

function regexTest(str, pattern) {
  return pattern.test(str)
}

export { sendLog }
